import { Component, Input, OnInit } from '@angular/core';
import { PlanInterval } from '../../../../shared/models/plans';
import { isMonthlyPlan } from '../../../../shared/utils/planUtils';

@Component({
  selector: 'cc-plan-brief-table',
  templateUrl: './plan-brief-table.component.html',
  styleUrls: ['./plan-brief-table.component.scss']
})
export class PlanBriefTableComponent implements OnInit {
  @Input() planName: string;
  @Input() pricePerUser: number;
  @Input() numberOfUsers: number;
  @Input() billingPeriod: PlanInterval;
  @Input() planState: 'CURRENT_PLAN' | 'NEW_PLAN';

  public billingPeriodKey: string;

  constructor() {}

  ngOnInit() {
    this.billingPeriodKey = isMonthlyPlan(this.billingPeriod) ? 'PLANS.PANEL.MONTHLY' : 'PLANS.PANEL.ANNUALLY';
  }

  getPriceLabel() {
    return this.pricePerUser;
  }
}
